import _ from 'underscore';

export default function normalize(state, entities, references) {
	state = Object.assign({
		items:[], 
		entities: {}
	}, state);
	
	entities = entities || [];
	references = references || state.references || [];

	return Object.assign({}, state, {
		items: state.items.concat(entities.map(entity => entity.id)),
		entities: Object.assign({}, state.entities, _.indexBy(entities, 'id')),
		references: references
	});
};


/** WEBPACK FOOTER **
 ** ./src/js/lib/normalize.js
 **/